import { useMemo } from "react";
import { DateDisplay } from "../../../components";
import { Spinner } from "../../../components/loaders";
import PageHeader from "../../../components/utilities/PageHeader";
import { useClientSetContext } from "../hooks/ClientSetContext";

const Statuses = {
    Loading: "Loading",
    Error: "Error",
    None: "None",
    Loaded: "Loaded"
}

const ClientSetPageHeader = () => {
    const { isFetchingSet, fetchSetIsError, selectedSet, refetchSet } = useClientSetContext();

    const status = useMemo(() => {
        if (isFetchingSet) return Statuses.Loading;
        if (fetchSetIsError) return Statuses.Error;
        if (!selectedSet) return Statuses.None;
        return Statuses.Loaded;
    }, [fetchSetIsError, isFetchingSet, selectedSet]);

    const { setName, createdDate, createdBy, modifiedDate, modifiedBy } = selectedSet || {};

    return <PageHeader className="d-flex justify-content-between align-items-end">
        <h3>Client Set Management</h3>
        <span>
            {status === Statuses.Loading && <Spinner />}
            {status === Statuses.Error && <span className="text-danger">
                Error fetching client set. Click <button className="anchor" onClick={refetchSet}>here</button> to retry
            </span>}
            {status === Statuses.Loaded && <h5 className="m-0">
                {setName}
            </h5>}
        </span>
        <span>
            {status === Statuses.Loaded && <h6 className="m-0">
                Created on <DateDisplay>{createdDate}</DateDisplay> by {createdBy}
            </h6>}
        </span>
        {status === Statuses.Loaded && modifiedDate && <h6 className="m-0">
            Modified on <DateDisplay>{modifiedDate}</DateDisplay> by {modifiedBy}
        </h6>}
    </PageHeader>;
}

export default ClientSetPageHeader;